import { ReactNode, useEffect, useLayoutEffect, useState } from "react";
import { Header } from "../header";
import { Footer } from "../footer";
import "../../assets/scss/components/layout.scss";
import { useSelector } from "react-redux";
import { StoreState } from "../../types/models/store";
import BackToTop from "./BackToTop";
import WebFont from 'webfontloader';
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LeftToolsBar from "../left-bar";
import useAuth from "../../hooks/useAuth";
interface Props{
    children: ReactNode;
}
export const DefaultLayout: React.FC<Props> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const { mobilemenu_toggle } = useSelector((state:StoreState) => state.auth);
  const { user, isAuthenticated } = useAuth() as any;

  function updateSize() {
    setIsMobile(window.innerWidth<1024);
  }
  useLayoutEffect(() => {
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  useEffect(()=>{
    updateSize();
    WebFont.load({
      google: {
        families: ['Montserrat', 'Axiforma', 'Roboto', 'Inter']
      }
    });
  },[]);
  return (
    <div className={"cugate-default-layout"+(isMobile?" mobile-size uk-text-center":"")+(mobilemenu_toggle?" offcanvas-menu":"")}>
      {user&&user.name!==''&&user.profile?.membership_level>1&&!user.client.id&&(
      <div className="alert-msg bg-warning py-2 text-center">
        {`Hi, ${user?.name}. Please set your company in `}<span className="focus color-blue" onClick={()=>navigate('/profile')}>profile</span>{` page. Then become our B2B client.`}
      </div>
      )}
      <Header />  
      {/* {
        location.pathname.indexOf('login')>-1||
        location.pathname.indexOf('register')>-1||
        location.pathname.indexOf('cugate')>-1||
        location.pathname.indexOf('dashboard')>-1||
        location.pathname.indexOf('membership')>-1||
        location.pathname.indexOf('trackeditor')>-1||
        location.pathname.indexOf('newtrack')>-1||
        location.pathname.indexOf('tageditor')>-1||
        location.pathname.indexOf('profile')>-1?(
        <></>
      ):(
        <Toolbar />
      )} */}
      {props.children}
      {location.pathname.indexOf('login')>-1||location.pathname.indexOf('register')>-1|| location.pathname.indexOf('recovery-password') > -1?(
        <></>
      ):(
        <Footer />
      )}

      {isAuthenticated&&(
        <LeftToolsBar/>
      )}
      
      <BackToTop />
      <ToastContainer />
    </div>
  );
};

export default DefaultLayout;
